var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4181 4.15137V4.30137H17.5681H19.5681C20.5883 4.30137 21.4181 5.13121 21.4181 6.15137V20.1514C21.4181 21.1715 20.5883 22.0014 19.5681 22.0014H5.56812C4.54796 22.0014 3.71812 21.1715 3.71812 20.1514V6.15137C3.71812 5.13121 4.54796 4.30137 5.56812 4.30137H7.56812H7.71812V4.15137V2.30137H9.41812V4.15137V4.30137H9.56812H15.5681H15.7181V4.15137V2.30137H17.4181V4.15137ZM19.5701 20.3014H19.7201L19.7201 20.1513L19.7181 8.15134L19.7181 8.00137H19.5681H5.56812H5.41812V8.15137V20.1514V20.3014H5.56812H19.5701Z",
    fill: "#656565",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6742 14.8434L15.8611 10.6565L17.063 11.8583L11.5681 17.3532L8.07322 13.8583L9.27508 12.6565L11.462 14.8434L11.5681 14.9495L11.6742 14.8434Z",
    fill: "#656565",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCalendarCheck);
export default __webpack_public_path__ + "static/media/icons-calendar-check.a86bccbdee7bf32e97e65373c0ac50a0.svg";
export { ForwardRef as ReactComponent };